<template>
  <label class="field" :class="classes">
    <span v-if="label" class="field__label">{{ label }}</span>
    <span v-if="ariaLabel" class="field__label field__label--hidden">{{
      ariaLabel
    }}</span>
    <div class="input">
      <input
        :id="inputId"
        :type="type"
        class="input__element"
        :autocomplete="autocomplete"
        :placeholder="placeholder"
        :disabled="disabled"
        :value="value"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @input="updateValue($event.target.value)"
      />
      <div v-if="errors.length" class="input__response">
        <ul>
          <li v-for="error of errors" :key="error.$uid">
            {{ error.$message }}
          </li>
        </ul>
      </div>
    </div>
  </label>
</template>

<script>
export default {
  name: "TextField",
  props: {
    theme: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "white"].includes(value);
      },
    },
    type: {
      type: String,
      default: "text",
    },
    autocomplete: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    validation: {
      type: Object,
      default: () => {},
    },
    label: {
      type: String,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    inputId: {
      type: String,
      default: null,
    },
  },
  emits: ["input"],
  data() {
    return {
      isFocused: false,
    };
  },
  computed: {
    classes() {
      return {
        "field--active": this.value,
        "field--focused": this.isFocused,
        "field--errors": this.errors.length,
        "field--disabled": this.disabled,
        "field--white": this.theme === "white",
      };
    },
    errors() {
      if (this.validation?.$dirty) {
        return this.validation?.$errors;
      }

      return [];
    },
  },
  methods: {
    updateValue(value) {
      // Emit input event to update the v-model in the parent component
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";
</style>
